import { DataChangeActionType } from '@wdx/shared/utils';

export const PENDING_CHANGE_LOCK_ALL = [
    DataChangeActionType.Add,
    DataChangeActionType.Remove,
];
